import type { CartItem } from "@repo/core/cart";

export function createCartItemSkeleton(item?: Partial<CartItem>): CartItem {
  return {
    partNo: String(Math.random() * 100) + "abc",
    quantity: 1,
    brand: "",
    id: 0,
    imageKey: "",
    isDiscounted: false,
    lineNo: 0,
    name: "",
    price: 0,
    priceListId: 0,
    priceOriginal: 0,
    totalDiscount: 0,
    totalGrossAmount: 0,
    totalVat: 0,
    vatPerItem: 0,
    ...item,
  };
}
